// i18n area 'cluster' — locale sv-SE (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.sv-SE.meta.json.
import type { enUS } from './cluster'

export const svSE: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Garantiåtkomster',
      subtitle: 'Nodens servicedörr: den skrivskyddade åtkomsten med tillfälligt lösenord och nödkontot med lösenordet från kassaskåpet',
      readOnlyTitle: 'Skrivskyddad åtkomst (trantor)',
      stateNone: 'stängd',
      stateGranted: 'öppen',
      stateGrantedPending: 'beviljad — tillämpas på noden',
      grantedBy: 'Beviljad av',
      grantedAt: 'Beviljad den',
      expiresAt: 'Går ut den',
      reason: 'Orsak',
      endedAt: 'Stängd',
      endedReason: {
        revoked: 'återkallad',
        expired: 'utgången (TTL)',
        reboot: 'omstart av noden',
        failed: 'ej tillämpad (uppgiften misslyckades)'
      },
      grant: 'Bevilja skrivskyddad åtkomst…',
      grantTitle: 'Bevilja skrivskyddad åtkomst',
      grantSubmit: 'Bevilja',
      grantError: 'Beviljandet avvisades',
      grantConfirm: 'TVirt skapar ett tillfälligt lösenord för systemanvändaren «trantor» (endast läsning: journal och diagnostik, ingen sudo) och sätter det på noden med en uppgift. Lösenordet visas EN enda gång, vid bekräftelsen; det upphör vid utgång, vid återkallelse eller vid nodens nästa omstart.',
      reasonLabel: 'Orsak',
      reasonHint: 'Varför du öppnar dörren: det hamnar i beviljandet, i granskningen och i journalen',
      ttlLabel: 'Varaktighet',
      ttlHours: '{n} h',
      revoke: 'Återkalla skrivskyddad åtkomst…',
      revokeTitle: 'Återkalla skrivskyddad åtkomst',
      revokeSubmit: 'Återkalla',
      revokeError: 'Återkallelsen avvisades',
      revokeConfirm: 'Beviljandet upphör nu och en uppgift låser användaren «trantor» på noden igen: det tillfälliga lösenordet slutar gälla.',
      passwordTitle: 'Skrivskyddat lösenord',
      passwordOnce: 'Detta lösenord visas EN enda gång: kopiera det nu. Det sparas ingenstans och kan inte läsas igen — tappar du bort det, bevilja på nytt.',
      passwordUser: 'Användare',
      passwordLabel: 'Lösenord',
      passwordHint: 'Giltigt till {until}, eller till nodens nästa omstart; användbart när beviljandeuppgiften är klar. Åtkomst: ssh trantor@<nodens adress>.',
      emergencyTitle: 'Senaste nödåtkomst (trantor-emergency)',
      lastLogin: '{time} via {via} från {from}',
      lastLoginNone: 'ingen observerad',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'konsol',
        sudo: 'sudo',
        unknown: 'okänd'
      },
      emergencyHint: 'Nödkontot «trantor-emergency» (full sudo) är alltid aktiverat med lösenordet som skapades vid nodens installation och förvaras i kassaskåpet: TVirt känner inte till det, roterar det inte och återställer det inte. Varje inloggning rapporteras här och i händelsejournalen.'
    },
    nodeFirewall: {
      tab: 'Brandvägg',
      title: 'Nodernas brandvägg',
      subtitle: 'Hållningen för det nftables-ruleset som varje nod tillämpar på sig själv — nodens enda brandvägg (firewalld är avaktiverat)',
      modeLabel: 'Hållning',
      mode: {
        disabled: 'Avaktiverad — inget ruleset på noderna',
        permissive: 'Tillåtande — räknar och loggar, kastar inget',
        enforced: 'Tillämpad — bara det härledda registret kommer in'
      },
      hint: {
        disabled: 'Som i dag: noderna bär inget ruleset. Gå över till tillåtande för att LÄSA vad som skulle kastas innan det kastas.',
        permissive: 'Varje nod tillämpar sitt härledda ruleset med policy accept: det som tillämpat läge skulle kasta räknas och loggas (journal-prefix «tvirt-node would-drop:»). Inget blockeras.',
        enforced: 'Varje nod tillämpar sitt härledda ruleset med policy drop: ssh och API från var som helst, store / live migration / overlay / Ceph bara från medlemmarna, nätverkstjänsternas lyssnare från det nätverk de betjänar. Varje växling är en apply med bekräftelse — en nod som inte lyckas bekräfta rullar tillbaka av sig själv.'
      },
      confirmTitle: 'Tillämpa nodernas brandvägg?',
      confirmBody: 'Varje nod tillämpar rulesetet med bekräftelse: den sonderar backend, store och ssh genom de nya reglerna inom tidsfristen och bekräftar — annars rullar den av sig själv tillbaka till det föregående rulesetet. Läs först räknarna från det tillåtande läget på noderna.',
      confirmSubmit: 'Tillämpa',
      confirmCancel: 'Avbryt',
      lensTitle: 'Nodens brandvägg',
      loadError: 'Kunde inte läsa in nodens brandväggslins',
      noReport: 'Ingen brandväggsrapport från den här noden ännu — workern rapporterar vid nästa pass',
      firewalldActive: 'firewalld kör på den här noden: nodbrandväggen vägrar tillämpas bredvid den (maska firewalld)',
      conditionUnconfirmed: 'Inget bekräftat ruleset ännu — noden är öppen',
      conditionRolledBack: 'Senaste applyn rullade tillbaka — samma generation försöks inte igen förrän registret ändras eller hållningen växlas på nytt',
      lastError: 'Senaste fel',
      posture: 'Hållning',
      observedAt: 'Observerat',
      desiredGeneration: 'Önskad generation',
      componentTitle: 'Nodkomponent',
      componentSubtitle: 'tvirt-node-firewall — tillämpar det bekräftade rulesetet vid boot, rullar av sig själv tillbaka ett obekräftat',
      componentAbsent: 'Komponenten har inte rapporterat ännu',
      phase: 'Fas',
      phases: {
        none: 'Aldrig tillämpat',
        applied: 'Tillämpat — väntar på bekräftelse',
        confirmed: 'Bekräftat',
        rolledBack: 'Tillbakarullat'
      },
      generation: 'Generation',
      appliedAt: 'Tillämpat',
      confirmedAt: 'Bekräftat',
      deadline: 'Tidsfrist för rollback',
      lastRollback: 'Senaste rollback',
      registryTitle: 'Härlett register',
      registrySubtitle: 'Portarna som den här noden öppnar, per klass och ursprung — härledda från klustret, aldrig redigerade för hand',
      registryEmpty: 'Inget härlett — hållningen avaktiverad utan bekräftat ruleset, eller ingen rapport ännu',
      colClass: 'Klass',
      colPort: 'Port',
      colSource: 'Källa',
      colOrigin: 'Ursprung',
      classes: {
        public: 'Publik',
        internode: 'Mellan noder',
        tenant: 'Tenant'
      },
      sourceMembers: 'bara medlemmarna',
      sourceAnywhere: 'var som helst',
      sourceBridge: 'på {iface}'
    },
    derivationDerived: 'härledd',
    derivationDiverged: 'avvikande',
    derivationDerivedTip: 'Nätverksdokumentet är HÄRLETT från fabric {fabric} och stämmer ännu med rendern på nuvarande indata — klicka för derivationsplanen.',
    derivationDivergedTip: 'Derivationen från fabric {fabric} ändrades efter senaste applyn (fabric, kablage, roller eller referenser) — klicka för den väntande diffen.',
    derivationRetiring: {
      one: '{n} adress dräneras',
      other: '{n} adresser dräneras'
    },
    standaloneHint: 'Den här noden har inget kluster: den är ännu inte installerad. Kluster skapas ELLER joinas vid installationen — tokenen som genereras från en medlems Server-tabell matas till installern (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Dina behörigheter täcker ett scope, inte hela klustret: flottinventariet — noder, inställningar och enheter — är bara synligt för klusteradministratörer.',
    phaseReady: 'Redo',
    phaseForming: 'Under bildande',
    storeMembers: 'Storens medlemmar',
    watermark: 'Konvergenströskel',
    configGeneration: 'Konfigurationsgeneration',
    converged: 'i fas',
    behind: 'efter — {m} / {n}',
    revision: 'Revision',
    rolesTitle: 'Nätverksroller',
    rolesSubtitle: 'Adresser per medlem för varje trafikklass — konnektiviteten bor i host-nätverket',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'ärver management',
    settingsTitle: 'Inställningar',
    settingsSubtitle: 'Säkerhetspolicy på klusternivå — utvärderad av varje nod från dess lokala replika',
    taskRetentionTitle: 'Kvarhållning av tasks',
    taskRetentionSubtitle: 'Enhetlig GC för alla tasks — avslutade tasks bortom åldern eller taket samlas in, aldrig de pågående',
    taskRetentionMaxAge: 'Maximal ålder (dagar)',
    taskRetentionMaxCount: 'Maximalt antal tasks',
    eventRetentionTitle: 'Händelselagring',
    eventRetentionSubtitle: 'Journalens GC — en politik oberoende av uppgifternas: uppgiften är en kö, händelsen är minne',
    eventRetentionMaxAge: 'Maximal ålder (dagar)',
    eventRetentionMaxCount: 'Högsta antal lagrade händelser',
    spaceThresholdsTitle: 'Utrymmeströsklar',
    spaceThresholdsSubtitle: 'När en lagring som fylls når journalen (och aviseringarna)',
    spaceLowPct: 'Varning från (% använt)',
    spaceCriticalPct: 'Kritiskt från (% använt)',
    spaceOrderError: 'Kritiskt kan inte ligga under varningen',
    spaceThresholdsHint: 'Endast ingångarna konfigureras: utgången härleds av motorn, 5 punkter under varje tröskel, så att en lagring på linjen aldrig blir en metronom',
    failoverReserveTitle: 'Failover-reserv',
    failoverReserveSubtitle: 'N+1 admission control — RAM som hålls fritt så att klustret kan starta om sin last efter nodförluster',
    failoverReserveTolerate: 'Antal noder vars förlust ska tolereras',
    failoverReserveOff: '0 — reserven avstängd: ingen start avvisas någonsin på grund av failover-kapacitet',
    failoverReserveOn: 'En start som skulle nagga på reserven avvisas med en 412 som förklarar siffrorna',
    networkShapingTitle: 'Bandbreddsrättvisa',
    networkShapingSubtitle: 'De tre typologivikterna i shaping-trädet per uplink — de verkar bara under konkurrens',
    networkShapingRest: 'Vikt för resten (kontrollplan, storage, repliker)',
    networkShapingOverlay: 'Vikt för overlay-nätverk',
    networkShapingLiveMigration: 'Vikt för live migration',
    networkShapingHint: 'Garanterad andel = vikt / summan av de tre (standard 300 / 100 / 200, var och en från 1 till 10000); på en ledig länk får varje klass ta hela bandbredden',
    debugModeTitle: 'Debug-läge',
    debugModeSubtitle:
      'Detaljerade fel i GUI:ns generiska varningar — för att se den verkliga orsaken när en ”misslyckad” åtgärd i själva verket lyckades',
    debugModeLabel: 'Debug-läge aktiverat',
    debugModeOn: 'Generiska felmeddelanden lägger till den bakomliggande orsaken — interna detaljer synliga för varje operatör',
    debugModeOffHint: 'Avstängt — generiska felmeddelanden förblir generiska, utan interna detaljer',
    nodeDetailsAction: 'Noddetaljer',
    node: {
      docTitle: 'Nod',
      notFound: 'Noden hittades inte',
      tabOverview: 'Översikt',
      tabStats: 'Statistik',
      tabNetwork: 'Nätverk',
      tabSettings: 'Lokala inställningar',
      identityTitle: 'Identitet',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'YSQL-port',
      revision: 'Konfigurationsrevision',
      versionsTitle: 'Observerade versioner',
      heartbeatSubtitle: 'Det senaste tillstånd som noden rapporterat om sig själv',
      cpuTitle: 'CPU',
      cpuModelTitle: 'CPU-modell',
      memoryTitle: 'Minne',
      hugePagesTitle: 'Enorma sidor',
      hugePagesPool: '{size}: {free} lediga av {total}',
      hugePagesNone: 'Ingen pool',
      hugePagesNoneHint: 'Noden har inga enorma sidor reserverade: virtuella maskiner som begär dem kan inte starta här. Poolen deklareras på noden med kärnparametrarna hugepagesz och hugepages eller genom att skriva nr_hugepages.',
      usageTitle: 'Aktuell användning',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'inte observerad — inget färskt sampel',
      statsNoData: 'Inga data i intervallet — nodens serier samplas av noden själv och serveras lokalt.',
      observedTitle: 'Observerat tillstånd',
      observedSubtitle: 'Tjänster och assets lokala för noden, som workern ser dem'
    },
    editRolesTitle: 'Redigera nätverksrollerna',
    memberNode: 'Nod',
    memberIp: 'IP-adress',
    addMember: 'Lägg till medlem',
    lmInherit: 'Använd management-adresserna',
    roleIpHint: 'Att lägga till och ta bort medlemmar är fritt; att ändra en befintlig medlems IP på plats avvisas — flödet för IP-migrering kommer i en senare runda.',
    roleError: 'Kunde inte uppdatera rollerna',
    nodesTitle: 'Noder',
    addNodeTitle: 'Lägg till nod i klustret',
    addNode: 'Lägg till nod',
    addNodeError: 'Kunde inte förregistrera noden',
    nodeName: 'Nodens namn',
    nodeNameHint: 'måste stämma överens med namnet som valdes vid installationen',
    nodeIp: 'Management-IP',
    colName: 'Namn',
    colPhase: 'Fas',
    colServices: 'Tjänster',
    colWatermark: 'Watermark',
    colLastSeen: 'Senaste kontakt',
    colUps: 'UPS',
    upsCordonChip: 'UPS-spärr',
    upsCordonTip: 'Noden dömde sig själv på sin UPS fakta ({time}): den häver spärren själv när nätet är stabilt och batteriet laddat',
    upsUnreachable: 'UPS onåbar',
    upsOnBattery: 'På batteri',
    upsOnLine: 'På nät',
    upsLowBattery: 'lågt batteri',
    upsNoEstimateChip: 'drifttid inte uppskattad',
    upsNoEstimateTip: 'UPS:en publicerar ingen uppskattning av drifttiden: noden döms enbart av UPS:ens LB-flagga (lågt batteri) — ställ in battery.runtime.low / LB på själva UPS:en',
    upsLaneTip: 'UPS-avstängningsbana sedan {since}: dömd av {by}',
    upsUnit: 'enhet',
    upsStatus: 'NUT-status',
    upsLoad: 'last',
    upsOnBatterySince: 'på batteri sedan',
    upsOnLineSince: 'på nät sedan',
    upsError: 'fel',
    upsObservedAt: 'observerad',
    upsNone: 'ingen UPS-enhet betjänar denna nod',
    upsBy: {
      runtime: 'drifttid under tröskeln',
      lowBattery: 'UPS:ens LB-flagga',
    },
    upsLane: {
      evacuate: 'evakuering',
      local: 'avstängning på plats',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'stoppar gäster',
      stoppingServices: 'stoppar tjänster',
      poweredOff: 'avstängd',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'UPS-enheter och trösklar: noden döms vid drifttid ≤ tröskel eller LB-flagga (alltid respekterad), återupptagning med hysteres',
    upsRuntimeThreshold: 'Tröskel för drifttid (s)',
    upsRuntimeThresholdHint: 'På batteri med uppskattad drifttid ≤ tröskel stängs noden av i ordning (standard 300)',
    upsResumeStable: 'Nät stabilt i (s)',
    upsResumeStableHint: 'Återuppta endast med oavbrutet nät sedan minst så många sekunder (standard 60)',
    upsResumeCharge: 'Minsta laddning vid återupptagning (%)',
    upsResumeChargeHint: 'Och batteri laddat till minst denna procent (standard 25)',
    upsPolicyNote: 'UPS:ens LB-flagga (lågt batteri) dömer alltid och kan inte stängas av; det finns ingen tröskel för tiden på batteri. Varje enhet kan skriva över de tre talen.',
    upsUnitNew: 'ny enhet',
    upsUnitSelectors: '{n} taggväljare (endast CLI)',
    upsUnitName: 'Enhetens namn',
    upsUnitMode: 'Läge',
    upsModeExternal: 'extern (annans upsd)',
    upsModeManaged: 'hanterad (UPS ansluten till en nod)',
    upsUnitUpsname: 'NUT-namn (upsname)',
    upsUnitHost: 'upsd-värd',
    upsUnitAttachedNode: 'Ansluten nod',
    upsUnitDriver: 'NUT-drivrutin',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Drivrutinens enhet',
    upsUnitDeviceHint: 'raden port= i ups.conf: tom = auto',
    upsUnitPort: 'upsd-port',
    upsUnitServedNodes: 'Betjänade noder',
    upsUnitServedNodesHint: 'nodnamn åtskilda med kommatecken (taggväljare går via CLI)',
    upsUnitOverrideHint: 'tom = klustrets standard',
    upsUnitAdd: 'Lägg till enhet',
    unreachableSince: 'Onåbar — senaste heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Overlay-dataplanet har ännu inte realiserat den aktuella overlay-konfigurationen',
    overlaysError: 'Senaste overlay-avstämningspasset misslyckades: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Väntar på join',
      'joining': 'Joinar',
      'member': 'Medlem'
    },
    tokenTitle: 'Join-token',
    tokenOnce: 'Visas bara nu — kopiera den direkt, den går inte att läsa igen',
    copy: 'Kopiera',
    copied: 'Kopierad',
    close: 'Stäng',
    revokeTitle: 'Återkalla förregistreringen',
    revoke: 'Återkalla',
    revokeError: 'Kunde inte återkalla registreringen',
    promote: 'Befordra till store member',
    demote: 'Ta bort rollen store-member',
    troubleshoot: 'Felsökning',
    promoteTitle: 'Befordra till store member',
    demoteTitle: 'Ta bort rollen store-member',
    promoteHint: 'Noden går med i YugabyteDB-masterkvorumet. Verklig HA kräver tre store members.',
    demoteHint: 'Noden lämnar masterkvorumet och stoppar sina store-tjänster.',
    storeError: 'Store-member-ändringen avvisades',
    attest: 'Attestera avstängd…',
    attestTitle: 'Attestera noden avstängd',
    attestSubmit: 'Attestera avstängd',
    attestConfirm: 'Du förklarar den här noden avstängd, på egen risk: att attestera en nod som i själva verket lever riskerar VM i dubbel körning. Dess tasks fallerar och dess VM:ars authority blir överförbar.',
    attestError: 'Attesteringen avvisades',
    attestedChip: 'attesterad avstängd',
    maintenanceChip: 'underhåll',
    guestToolsChip: 'TVirt Guest Tools (ISO-asset lokal för noden)',
    maintenanceEnter: 'Aktivera underhåll',
    maintenanceExit: 'Avsluta underhåll',
    maintenanceEnterTitle: 'Aktivera underhåll',
    maintenanceExitTitle: 'Avsluta underhåll',
    maintenanceEnterSubmit: 'Aktivera underhåll',
    maintenanceExitSubmit: 'Avsluta underhåll',
    maintenanceEnterConfirm: 'Noden spärras av och töms: nätverkstjänsterna och App-instanserna vars authority den håller överförs (instanserna kallt: stoppade och skördade här, återskapade på målnoden — driftstopp), körande VM:er live-migreras där det går och stoppas annars snyggt, pågående uppgifter avslutas, nytt arbete hålls tillbaka och stoppade VM:er förlorar sin authority — Proximity placerar dem på nytt vid nästa start. Inget kommer tillbaka av sig självt när underhållet är slut.',
    maintenanceExitConfirm: 'Noden börjar arbeta igen och Proximity räknar åter med den vid placeringen. VM:arna kommer tillbaka först när de startas.',
    maintenanceError: 'Underhållsbegäran avvisades',
    maintenancePlanTitle: 'Evakueringsplan',
    maintenancePlanLoading: 'Beräknar evakueringsplanen…',
    maintenancePlanError: 'Kunde inte läsa in evakueringsplanen — dräneringen migrerar ändå där det går och stoppar resten.',
    maintenancePlanEmpty: 'Inget att evakuera på den här noden — ingen aktiv nätverkstjänst, ingen App-instans som ska köras, ingen körande VM.',
    maintenancePlanSummary: '{migrate} objekt migrerar (VM:er, nätverkstjänster, App-instanser), {stop} stoppas eller stannar där de är.',
    maintenancePlanReserve_ok: 'Failover-reserv efter tömningen: intakt — {headroom} GiB förblir startbara med tolerans för förlust av {n} nod(er).',
    maintenancePlanReserve_eroded: 'Failover-reserv efter tömningen: nästan förbrukad — bara {headroom} GiB återstår av de {reserve} GiB som hålls fria för {n} nodfel.',
    maintenancePlanReserve_exhausted: 'Failover-reserv efter tömningen: UTTÖMD — det saknas {headroom} GiB av de {reserve} GiB som krävs för att tolerera {n} nodfel. Så länge den här noden är ute avvisas nya VM-starter.',
    maintenancePlanReserve_unknown: 'Failover-reserv efter tömningen: kan inte beräknas — ingen kvarvarande nod har deklarerat sitt minne.',
    maintenancePlanReserveHugePages: 'Enorma sidor på {size} efter tömningen — fria: {free} av {capacity}, krävda som reserv: {reserve}.',
    maintenancePlanActionMigrate: 'migreras',
    maintenancePlanActionMigrateWarning: 'migreras (soft-regel överträdd)',
    maintenancePlanActionStop: 'stoppas',
    maintenancePlanActionBlocked: 'blockerad',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'nätverkstjänst',
    maintenancePlanKindApp: 'App-instans',
    maintenancePlanColdMove: 'Kall flytt: podden stoppas och skördas här och återskapas på målnoden av dess worker — driftstopp till målworkerns nästa pass.',
    caFingerprint: 'Fingerprint för klustrets CA',
    staleChip: 'inte uppdaterad',
    troubleshootTitle: 'Felsökning av storen',
    restartStore: 'Starta om store-tjänsterna',
    restartHint: 'Om storen krånglar, starta om dess tjänster. Avancerat — använd med försiktighet.',
    restartQueued: 'Omstartstask köad',
    restartError: 'Kunde inte starta om tjänsterna',
    svcActive: 'aktiv',
    svcWanted: 'önskad, inte aktiv',
    svcStopped: 'stoppad',
    noServices: 'Ingen tjänst rapporterad'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Hela klustrets GPU-inventarium grupperat per modell — korten observerade per nod, med de markerade registreringarna och deras taggar',
    usbTitle: 'USB-resurser',
    usbSubtitle: 'Hela klustrets USB-inventarium grupperat per modell — enheterna observerade per nod, med registreringar enligt båda modellerna (per enhet, per port) och deras taggar',
    markedChip: '{n} användbara för TVirt',
    orphanChipGpu: '{n} föräldralösa',
    orphanChipUsb: '{n} föräldralösa',
    colNode: 'Nod',
    colRegistration: 'Registrering',
      noRegsHint: 'Ingen registrering — enheten markeras "användbar för TVirt" från nodens dialog (Noder › nod › Inställningar).',
      colDevice: 'Enhet',
      colObserved: 'Observerade',
      colRegs: 'Registreringar',
      regsNone: 'inga',
      colPci: 'PCIe-adress',
      colIdentity: 'Identitet / port',
      colClasses: 'Klasser (taggar)',
      colActions: 'Åtgärder',
      manageOnNode: 'Hantera på noden {node} (markeringen bor i nodens dialog)',
      introTitle: 'Klusterinventariet över USB- och PCIe-enheter användbara för TVirt©.',
      introStep1: '1. Noderna upptäcker själva sina GPU:er och USB-enheter (inventering i heartbeaten).',
      introStep2: '2. En enhet markeras "användbar för TVirt" från NODENS dialog (Noder › nod › Inställningar) — markeringen binder den till vfio och registrerar den här.',
      introStep3: '3. Här ger du registreringarna deras KLASSER via taggar (t.ex. gpu_class=compute): VM:arnas krav begär en klass, och schedulern väljer en nod med en kompatibel ledig enhet.',
    colMode: 'Modell',
    colState: 'Status',
    colNotes: 'Anteckningar',
    colTags: 'Taggar',
    modeDevice: 'per enhet',
    modePort: 'per port',
    usable: 'användbar',
    orphanGpu: 'föräldralös',
    orphanUsb: 'föräldralös',
    hubChip: 'hubb',
    orphanPortsTitle: 'Per-port-registreringar utan ansluten enhet — anslut en enhet igen eller avmarkera dem från noden',
    gpusEmpty: 'Ingen GPU observerad på någon nod ännu',
    usbEmpty: 'Ingen USB-enhet observerad på någon nod ännu'
  },
  settings: {
    passwordMinLength: 'Minsta lösenordslängd',
    sessionIdle: 'Timeout för inaktiv session (minuter)',
    lockoutThreshold: 'Låsning efter misslyckade försök',
    lockoutDuration: 'Låsningens varaktighet (minuter)',
    keyboardLayout: 'Tangentbordslayout',
    keyboardLayoutHint: 't.ex. sv, en-us — tomt för QEMU-standarden',
    syslogEndpoint: 'Syslog-endpoint',
    syslogEndpointHint: 'host:port — tomt för att inaktivera vidarebefordran',
    syslogTls: 'TLS',
    maxQueued: 'Max antal köade tasks',
    concurrency: 'Workerns samtidighet',
    concurrencyHint: 'Tillämpas i farten av workern',
    notesTitle: 'Anteckningar',
    save: 'Spara',
    saved: 'Inställningarna sparade',
    saveError: 'Kunde inte spara inställningarna'
  },
  localSettings: {
    derivedChip: 'härledd',
    derivedTip: 'Detta device ÄGS av fabric-derivationen (H2): editorn vägrar röra det — ändra fabricen (eller kablaget) och tillämpa igen, eller ta tillbaka det nedan.',
    takeOwnership: 'Ta ägarskap',
    takeOwnershipTitle: 'Ta ägarskap (take-ownership)',
    takeOwnershipConfirm: '{name} lämnar fabric-blocket och blir åter ett MANUELLT device som denna editor styr. Noden blir avvikande, och nästa derivations-apply avslår på den (manualConflict) tills du byter namn på eller tar bort det — eller rättar fabricen.',
    nodeSettingsTitle: 'Nodinställningar',
    nodeSettingsSubtitle: 'Det den här noden tillämpar — task-kön, konsolen, loggvidarebefordran — plus dess taggar och anteckningar',
    baseTitle: 'Host-reserver (TVirt Proximity)',
    baseSubtitle: 'CPU och RAM reserverade för hostens operativsystem — indata till den empiriska kapacitet som Proximity placerar VM:arna med',
    baseMemory: 'Bas-RAM (MiB)',
    baseMemoryHint: 'Observerat totalt: {total} MiB. Användbart för VM = totalt − bas − RAM för de påslagna VM som placerats här.',
    baseMemoryHintNoTotal: 'Användbart för VM = observerat totalt − bas − RAM för de påslagna VM som placerats här.',
    baseCpu: 'Bas-CPU-kärnor',
    baseCpuHint: 'Observerade logiska CPU:er: {total}. Används bara som rankningsvikt — vCPU-overcommit är normalt.',
    baseCpuHintNoTotal: 'Används bara som rankningsvikt — vCPU-overcommit är normalt.',
    baseHint: 'RAM är den hårda admissionsgrinden: en VM som inte ryms i det användbara RAM-minnet avvisas med ett talande fel. Höj basen på hostar som huserar store-medlemmar eller Ceph-daemoner.',
    placementTitle: 'Fysisk placering',
    placementSubtitle: 'Var den här servern fysiskt står — deklarerat en gång, för vad det än behövs',
    placementHint: 'Placeringen styr CRUSH-hierarkin för varje Ceph-kluster med en OSD på den här servern: att spara en ändring riktar om deras mappar via task (host → rack → … → root). Partiella deklarationer är lagliga — tomma nivåer kollapsar. Namnen delas över hela mappen: två servrar i samma rack deklarerar samma rack-namn.',
    placementNameInvalid: 'DNS-safe namn (gemener, siffror, bindestreck)',
    placementEmpty: 'Tomt = inte deklarerat',
    placementLevel: {
      chassis: 'Chassi',
      rack: 'Rack',
      row: 'Rad',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Rum',
      datacenter: 'Datacenter',
      zone: 'Zon',
      region: 'Region'
    },
    cablingTitle: 'Kablage',
    cablingSubtitle: 'Vilken switchport varje gränssnitt är kopplat till — deklarationen bor på noden (Annex O.9)',
    cablingHint: 'En kabel per NIC, en kabel per port över hela flottan (API:et avvisar och namnger innehavaren). Att kabla mot en port som är medlem i en LAGG är lagligt — det är bond-fallet: den framtida härledningen renderar det som LACP.',
    cablingInterface: 'Gränssnitt',
    cablingNotCabled: '— inte kopplad —',
    cablingNoInterfaces: 'Inget nätverksgränssnitt observerat',
    disksTitle: 'Diskar',
    disksSubtitle: 'Observerade blockenheter — en skanning per avstämningspass; märk här upp de diskar som kan användas som Ceph-OSD (N.15: behörigheten är explicit)',
    colDataDisk: 'Datadisk',
    dataDisksHint: 'Att kryssa i en enhet förklarar den användbar som OSD; serienumret är dess identitetsnål — kopierat från hårdvaran när disken rapporterar det, myntat (tvirt-…) annars. Cephs registreringsdialog erbjuder bara de deklarerade diskarna.',
    diskDeclaredSerial: 'deklarerat',
    diskNotObserved: 'deklarerad men inte observerad — anslut enheten igen eller ta bort krysset',
    noDisks: 'Ingen blockenhet observerad ännu',
    colSerial: 'Serienummer',
    colModel: 'Modell',
    colSize: 'Storlek (GiB)',
    colDiskType: 'Typ',
    colInUse: 'I bruk',
    colObservedAt: 'Observerad',
    diskInUse: 'i bruk',
    diskFree: 'ledig',
    diskMounted: 'monterad',
    diskPartitions: 'partitioner',
    passthroughTitle: 'Passthrough-enheter',
    passthroughSubtitle: 'Observerade GPU:er och USB-enheter — märk här upp vad TVirt får skicka in till VM:arna; markeringen registrerar enhetens identitet (runda U1+G1)',
    passthroughHint: 'Markeringen registrerar enheten (ett stabilt id — målet för taggar och klasskrav). En markerad GPU får HELA sin IOMMU-grupp bunden till vfio-pci i klump — den lämnar hosten omedelbart; avmarkeringen hakar tillbaka den nativa drivrutinen. För USB finns båda de ratificerade modellerna: per enhet (vendor+produkt, var den än sitter) och per fysisk port (VM:en får vad som än sitter i den). USB binds inte vid markeringen — attachen sker vid VM:ens runtime.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Användbar för TVirt',
    colGpu: 'GPU',
    colPciAddress: 'PCI-adress',
    colDriver: 'Drivrutin',
    colVerdict: 'Bedömning',
    gpuEligible: 'Lämplig',
    gpuIneligible: 'Inte lämplig',
    gpuReason: {
      'no-iommu': 'IOMMU inte aktiv på hosten',
      'group-spans-slots': 'IOMMU-gruppen inte isolerad: den sträcker sig över andra slots',
      'multiple-display': 'IOMMU-gruppen inte isolerad: mer än en videofunktion',
      'foreign-function': 'IOMMU-gruppen inte isolerad: den innehåller en främmande funktion'
    },
    vfioNotReady: 'IOMMU är inte aktiv på den här hosten: ingen GPU är lämplig förrän host-plattformen aktiverar den (OEM-ISO) — TVirt rör aldrig kernel args i runtime.',
    vfioMissingKernelArg: 'IOMMU är inte aktiv på den här hosten: firmwaren rapporterar VT-d/AMD-Vi (ACPI-tabell DMAR/IVRS finns) men kernel arg saknas — lägg till intel_iommu=on (Intel) eller ta bort amd_iommu=off (AMD) från kärnans command line och starta om. TVirt rör aldrig kernel args i runtime.',
    vfioFirmwareDisabled: 'IOMMU är inte aktiv på den här hosten: VT-d/AMD-Vi är inaktiverat i firmwaren (ingen ACPI-tabell DMAR/IVRS) eller så saknar CPU:n stöd — aktivera det i firmware-setupen, ingen kernel arg kan slå på det. TVirt rör aldrig hosten i runtime.',
    gpuBindError: 'vfio-pci-bind misslyckades på {address}: {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Brandvägg på ohanterade bryggor',
    firewallBridgesSubtitle: 'De handbyggda bryggorna på den här noden vars setup samtycker till TVirt-renderade brandväggs-chains på de anslutna guest-NIC:arna',
    firewallBridgesHint: 'TVirt rör aldrig den främmande bryggan — chainen förankras på tap/veth, som alltid är TVirts egen. Listan är en samtyckesgrind: default-deny och anti-spoof kan knäcka det en manuell setup förväntar sig, så en NIC med brandvägg på en ohanterad brygga som INTE står här avvisas med ett talande fel.',
    firewallBridgesEmpty: 'Ingen ohanterad brygga samtycker till TVirt-renderade brandväggs-chains på den här noden.',
    firewallBridgeAdd: 'Lägg till brygga',
    firewallBridgeInvalid: 'Inte ett Linux-gränssnittsnamn (1-15 tecken, utan snedstreck eller mellanslag)',
    firewallBridgeDuplicate: 'Namnet står redan i listan',
    colMarkDevice: 'Per enhet',
    colMarkPort: 'Per port',
    usbHub: 'hubb',
    colUsbId: 'Vendor:Product',
    colPort: 'Port',
    passthroughOrphan: 'föräldralös — registrerad men inte längre detekterad: anslut den igen eller avmarkera den',
    noGpus: 'Ingen GPU observerad ännu',
    noUsb: 'Ingen USB-enhet observerad ännu',
    networkGeneration: 'Nätverksgeneration',
    applied: 'Tillämpad',
    converged: 'i fas',
    behind: 'efter — {m} / {n}',
    notConfigured: 'inte konfigurerad',
    rollbackBody: 'Tillämpningen av generation {gen} misslyckades: {error}',
    rolledBackChip: 'rollback utförd',
    nicsTitle: 'NIC',
    nicsSubtitle:
      'Registret över hanterade NIC:ar — registreringen ÄR förvaltningsdeklarationen: en registrerad NIC utan konfiguration rörs inte (clear-if förklarar den uttryckligen ren), en oregistrerad enhet rörs aldrig',
    addNic: 'Registrera NIC',
    addNicTitle: 'Registrera NIC (add-nic)',
    delNic: 'Avsluta förvaltningen',
    delNicTitle: 'Avsluta förvaltningen (del-nic)',
    delNicConfirm:
      'Förvaltningen av {name} avslutas: registerposten och dess konfiguration raderas och TVirt-profilen tas bort — enheten förblir som Linux har den.',
    nicName: 'Enhetens namn',
    nicMac: 'Permanent MAC-adress',
    nicMacHint: 'den permanenta hårdvaru-MAC:en — den stabila identiteten fastslagen av TVirt Server Installer',
    colObserved: 'Observerad',
    nicObserved: 'observerad',
    nicNotObserved: 'inte observerad',
    nicMacMismatch: 'Avvikande MAC — observerad {mac}',
    noNics: 'Ingen NIC registrerad — registrera en enhet för att börja förvalta den',
    noManagedDevices: 'Ingen förvaltad enhet — registrera en NIC först, allt bygger på registret',
    inventoryTitle: 'Observerade enheter',
    inventorySubtitle: 'Uppdaterade vid varje avstämningspass av nodens worker — valideringen kontrollerar enhetsnamnen mot det här inventariet',
    colDevice: 'Enhet',
    colType: 'Typ',
    colMac: 'MAC',
    colLink: 'Länk',
    colSpeed: 'Hastighet',
    colTopology: 'Topologi',
    colMtu: 'MTU',
    colAddresses: 'Adresser',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP aggregerar inte',
    noInventory: 'Ingen enhet rapporterad hittills',
    interfacesTitle: 'Gränssnitt',
    interfacesSubtitle:
      'L3-konfiguration för registrerade NIC:ar och deklarerade logiska enheter — set-if ersätter hela blocket, edit-if finjusterar egenskaperna, clear-if tömmer det (explicit rensning)',
    colConfig: 'Önskad konfiguration',
    clean: 'ren',
    setIf: 'Ändra adresseringen',
    setIfTitle: 'Ändra adresseringen (set-if)',
    editIf: 'Ändra egenskaperna',
    editIfTitle: 'Ändra egenskaperna (edit-if)',
    clearIf: 'Töm konfigurationen',
    clearIfTitle: 'Töm konfigurationen (clear-if)',
    clearIfConfirm: 'Gränssnittets konfiguration töms. Ett rent gränssnitt är förutsättningen för att göra det till medlem i bond/bridge eller parent för VLAN.',
    ip4Mode: 'IPv4-läge',
    ip6Mode: 'IPv6-läge',
    modeUnconfigured: 'Inte konfigurerat',
    modeStatic: 'Statiskt',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4-adresser',
    ip6Addresses: 'IPv6-adresser',
    addressesHint: 'CIDR, kommaseparerade',
    gw4: 'IPv4-gateway',
    gw6: 'IPv6-gateway',
    dns: 'DNS-servrar',
    dnsHint: 'kommaseparerade — tomt nollställer DNS (set-if ersätter blocket)',
    routes4: 'Statiska IPv4-rutter',
    routes6: 'Statiska IPv6-rutter',
    routeTo: 'Destination (CIDR)',
    routeVia: 'Via',
    addRoute: 'Lägg till rutt',
    routesChip: 'rutter',
    mtu: 'MTU',
    mtuHint: 'tomt = drivrutinens standard',
    vlansTitle: 'VLAN',
    addVlan: 'Lägg till VLAN',
    addVlanTitle: 'Lägg till VLAN (add-vlan)',
    delVlanTitle: 'Radera VLAN (del-vlan)',
    vlanParent: 'Parent-gränssnitt',
    vlanId: 'VLAN-ID',
    vlanPreview: 'Enhetens namn',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Ingen VLAN deklarerad',
    bondsTitle: 'Bond',
    addBond: 'Lägg till bond',
    addBondTitle: 'Lägg till bond (add-bond)',
    editBondTitle: 'Redigera bond',
    editBond: 'Spara bond',
    delBondTitle: 'Radera bond (del-bond)',
    bondName: 'Bondens namn',
    members: 'Medlemmar',
    membersHint: 'medlemmarna måste vara rena gränssnitt (utan L3-konfiguration)',
    bondMode: 'Läge',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Primär medlem',
    rate: 'LACP-rate',
    hash: 'Hash-policy vid sändning',
    colMembers: 'Medlemmar',
    colMode: 'Läge',
    noBonds: 'Ingen bond deklarerad',
    bridgesTitle: 'Bridge',
    addBridge: 'Lägg till bridge',
    addBridgeTitle: 'Lägg till bridge (add-bridge)',
    editBridgeTitle: 'Redigera bridge',
    editBridge: 'Spara bridge',
    delBridgeTitle: 'Radera bridge (del-bridge)',
    bridgeName: 'Bridgens namn',
    stp: 'STP',
    stpOn: 'STP aktivt',
    stpOff: 'STP avstängt',
    colStp: 'STP',
    noBridges: 'Ingen bridge deklarerad',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Sätt hostname',
    setHostnameTitle: 'Sätt hostname (set-hostname)',
    hostnameHint: 'Endast OS-identitet — nodens namn i klustret rörs inte',
    notSet: 'inte satt',
    staticHostsTitle: 'Statiska host-poster',
    addStaticHost: 'Lägg till post',
    addStaticHostTitle: 'Lägg till statisk host-post',
    delStaticHostTitle: 'Radera statisk host-post',
    hostIp: 'IP-adress',
    hostNames: 'Namn',
    hostNamesHint: 'separerade med komma eller mellanslag',
    colIp: 'IP',
    colNames: 'Namn',
    noStaticHosts: 'Ingen statisk host-post',
    delConfirm: '{name} tas bort ur det önskade dokumentet — nodens worker konvergerar med en NetworkManager-checkpoint och automatisk rollback.',
    remove: 'Ta bort',
    opError: 'Nätverksoperationen avvisades'
  }
}
